import type from "./type";

export default type("text/plain", function(xhr) {
  return xhr.responseText;
});



//////////////////
// WEBPACK FOOTER
// ./~/d3-request/src/text.js
// module id = 783
// module chunks = 0